export enum ButtonColorEnum {
    RED = 'red',
    BLUE = 'blue',
    BLACK_WHITE = 'black-white', // Dark-Mode: Black, Light-Mode: White
    CUSTOM_DARK_HOVER = 'custom-dark-hover',
    LINK = 'link',
    CUSTOM = 'custom',
}
